var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Http from '@shared-app/lib/apis/http';
// The backend returns a file's `types` as a map ({wall: [...], slab: [...]}); the file list
// treats it as a flat string[] (the solution types present). Normalize both shapes here.
const toTypeArray = (types) => {
    if (Array.isArray(types))
        return types;
    if (types && typeof types === 'object')
        return Object.keys(types);
    return [];
};
export const FileService = {
    getFiles: () => __awaiter(void 0, void 0, void 0, function* () {
        const files = yield Http.get('/files');
        return (files || []).map(file => (Object.assign(Object.assign({}, file), { types: toTypeArray(file.types) })));
    }),
    getFile: (fileId) => Http.get(`/files/${fileId}`),
    getConfig: () => Http.get('/config?article=false'),
    /** Fetches an S3-backed asset (image/dwg) as a Blob via the `/filenames/*` presigned redirect. */
    getBlob: (key) => Http.get(`/filenames/${key}`, {}, {}, { responseType: 'blob' })
};
export const SolutionService = {
    get: (fileId, solutionId) => Http.get(`/files/${fileId}/solutions/${solutionId}`),
    updateName: (fileId, solutionId, name) => Http.put(`/files/${fileId}/solutions/${solutionId}/name`, { name }),
    updateDescription: (fileId, solutionId, description, target) => Http.put(`/files/${fileId}/solutions/${solutionId}/description`, Object.assign({ description }, target)),
    updateSystems: (fileId, solutionId, systems) => Http.put(`/files/${fileId}/solutions/${solutionId}/systems`, { systems }),
    updateParameters: (fileId, solutionId, payload) => Http.put(`/files/${fileId}/solutions/${solutionId}/parameters`, payload),
    // schemas.Bom is a JSON array, so the body is the BOM list itself.
    updateBom: (fileId, solutionId, bom) => Http.put(`/files/${fileId}/solutions/${solutionId}/bom`, bom),
    remove: (fileId, solutionId) => Http.delete(`/files/${fileId}/solutions/${solutionId}`)
};
